import ContactInfoCard from "./ContactInfoCard";

export default ContactInfoCard;
